import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Preloader from '../Preloder/Preloader';
import './Studentexam.css';

const WalletExam = () => {
    const [loading, setLoading] = useState(false);
  
    const [formData, setFormData] = useState({
        name: '',
        fathername: '',
        UserId: '',
        school: '',
        medium: '',
        standard: '',
        bonafideImage: null,
        photoImage: null,
        referralId: '',
        orderId:'',
        walletreferralId:localStorage.getItem("UserId")
    });
    console.log("ref:",formData);

    
    const [paymentState, setPaymentState] = useState('');
    const [merchantOrderId, setMerchantOrderId] = useState('');
    const [message, setMessage] = useState('');
    const [paymentUrl, setPaymentUrl] = useState('');
    
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const OrderId = searchParams.get("orderId");

    const MediumtoStandard = {
        Tamil: ['VI', 'VII', 'VIII', 'IX', 'X', 'XI MathsBiology', 'XI Computer Science', 'XI Science', 'XI Commerce', 'XI Electrical', 'XI Civil', 'XI History', 'XII MathsBiology', 'XII Computer Science', 'XII Science', 'XII Commerce', 'XII Electrical', 'XII Civil', 'XII History','ITI ' ,'Diploma','PG (Postgraduate)','UG  (Undergraduate) '],
        English: [ 'VI', 'VII', 'VIII', 'IX', 'X', 'XI MathsBiology', 'XI Computer Science', 'XI Science', 'XI Commerce', 'XI Electrical', 'XI Civil', 'XI History', 'XII MathsBiology', 'XII Computer Science', 'XII Science', 'XII Commerce', 'XII Electrical', 'XII Civil', 'XII History','ITI ' ,'Diploma','PG (Postgraduate)','UG  (Undergraduate) ']
    };

  

    useEffect(() => {
    console.log("formData after update:", formData);
}, [formData]);

console.log("location.state.referralid:", location.state?.referralId);


useEffect(() => {
  const {
  studentName = '',
  UserId = '',
  referralId = '',
  paymentState: passedPaymentState
} = location.state || {};

  const savedName = sessionStorage.getItem("studentName");
  const savedUserId = sessionStorage.getItem("UserId");
  const savedReferralId = localStorage.getItem("UserId");
const generatedOrderId = generateOrderId();
  const finalReferralId = referralId || savedReferralId || '';
  console.log("Generated Order ID:", generateOrderId);
  console.log("➡ Final referralId to set:", finalReferralId);

  setFormData(prev => ({
    ...prev,
    name: studentName || savedName || '',
    UserId: UserId || savedUserId || '',
    referralId: finalReferralId,
    orderId: generatedOrderId,
  }));

  if (passedPaymentState) {
    setPaymentState(passedPaymentState);
  }
}, [location.state]);


    
   console.log("location.statE.referralId:", location.state?.referralId);


    
    console.log('localStorage referralId:', localStorage.getItem('UserId'));
    console.log("location.state:", location.state);



  
   

    const generateOrderId = () => {
        const timestamp = Date.now();
        const random = Math.floor(Math.random() * 10000);
        return `WALLET_${timestamp}_${random}`.slice(0, 63);
    };
    console.log("Sending orderId:", formData.orderId);
console.log("Type of orderId:", typeof formData.orderId);

const handleWalletPay = async () => {
    // prevent default form submit

  // Validate required fields first
  const requiredFields = ['name', 'fathername', 'school', 'medium', 'standard', 'bonafideImage', 'photoImage'];
  const missingFields = requiredFields.filter(field => !formData[field]);
  if (!formData.orderId || typeof formData.orderId !== 'string') {
  console.error("🚨 Invalid or missing orderId:", formData.orderId);
}

  if (missingFields.length > 0) {
    setMessage(`Please fill all required fields: ${missingFields.join(', ')}`);
    return;
  }

  setLoading(true);
  setMessage(''); // clear previous messages

  try {
    // Example: submit form data to backend (adjust URL & payload as needed)
    const formPayload = new FormData();
    formPayload.append('name', formData.name);
    formPayload.append('fathername', formData.fathername);
    formPayload.append('school', formData.school);
    formPayload.append('medium', formData.medium);
    formPayload.append('standard', formData.standard);
    formPayload.append('bonafideImage', formData.bonafideImage);
    formPayload.append('UserId',formData.UserId);
    formPayload.append('photoImage', formData.photoImage);
    // formPayload.append('referralId', formData.referralId);
    formPayload.append('orderId', formData.orderId.toString());
    formPayload.append('walletreferralId',formData.walletreferralId);

    const response = await axios.post(`${process.env.REACT_APP_API}/form/submit-wallet`, formPayload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    if (response.status === 200) {
      setMessage("✅ Form submitted successfully!");
      setTimeout(() => {
        navigate('/studentadd')
      }, 1500);
      
    } else {
      setMessage("⚠️ Failed to submit the form.");
    }
  } catch (error) {
    console.error('Submission error:', error);
    setMessage(error.response?.data?.message || 'Submission failed.');
  } finally {
    setLoading(false);
  }
};




  
    
    
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: files ? files[0] : value
        }));
    };

    const handleMediumChange = (e) => {
        const medium = e.target.value;
        setFormData(prev => ({
            ...prev,
            medium,
            standard: '' // Reset standard when medium changes
        }));
    };

    

    const standards = MediumtoStandard[formData.medium] || [];

  // Wallet concept
   const [accountBalance, setAccountBalance] = useState(0);
  const [showConfirmBar, setShowConfirmBar] = useState(false);
  const [canApply, setCanApply] = useState(false);
   const referralId = localStorage.getItem('UserId')

    useEffect(() => {
    const fetchWalletBalance = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/auth/isappalayed`);
        const applications = response.data;

        const matched = applications.filter(app => app.referralId === referralId);
        const matchminus=applications.filter(sum => sum.walletreferralId === referralId)
        const balance = matched.length * 40;
        const wallet =matchminus.length * 70;

        const totalbalance=balance-wallet


        setAccountBalance(totalbalance);
        setCanApply(balance >= 70);
      } catch (err) {
        console.error("Failed to fetch wallet balance", err);
      }
    };

    fetchWalletBalance();
  }, []);

    const handleApplyByWallet = () => {
    setShowConfirmBar(true);
  };

  


    return (
        <div>
            <div style={{ marginBottom: '50px' }}>
                <Link to="/" className="logo_image">
                    <img src="assets/headimg.jpg" alt="Cleenhearts HTML" style={{ width: '100%' }} />
                </Link>
            </div>
            
            <section className="student-exam-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="exam-form-card">
                                <h2 className="text-center mb-4">Admin Exam Registration</h2>
                                
                                {message && (
                                    <div className={`alert ${message.includes('success') ? 'alert-success' : 'alert-danger'}`}>
                                        {message}
                                    </div>
                                )}

                                <form onSubmit={(e) => {
  e.preventDefault();
  handleWalletPay();
}}>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    placeholder="Full Name"
                                                    value={formData.name}
                                                    name="name"
                                                    onChange={handleChange}
                                                    required
                                                    readOnly
                                                />
                                                <label htmlFor="name">Student Name</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="fathername"
                                                    placeholder="Father's Name"
                                                    value={formData.fathername}
                                                    name="fathername"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <label htmlFor="fathername">Father's Name</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <select
                                                    id="medium"
                                                    name="medium"
                                                    className="form-control"
                                                    value={formData.medium}
                                                    onChange={handleMediumChange}
                                                    required
                                                >
                                                    <option value="">Select Medium</option>
                                                    {Object.keys(MediumtoStandard).map(medium => (
                                                        <option key={medium} value={medium}>{medium}</option>
                                                    ))}
                                                </select>
                                                <label htmlFor="medium">Medium</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <select
                                                    id="standard"
                                                    name="standard"
                                                    className="form-control"
                                                    value={formData.standard}
                                                    onChange={handleChange}
                                                    disabled={!formData.medium}
                                                    required
                                                >
                                                    <option value="">Select Standard</option>
                                                    {standards.map((standard, index) => (
                                                        <option key={index} value={standard}>{standard}</option>
                                                    ))}
                                                </select>
                                                <label htmlFor="standard">Standard</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="school"
                                                    placeholder="School / College"
                                                    value={formData.school}
                                                    name="school"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <label htmlFor="school">School/College</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="bonafideImage"
                                                    name="bonafideImage"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <label htmlFor="bonafideImage">Bonafide / ID Photo</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="photoImage"
                                                    name="photoImage"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <label htmlFor="photoImage">Upload Photo</label>
                                            </div>
                                        </div>

                                      <div className="container mt-4">
    <h3>Apply using Wallet</h3>
    <p>Wallet Balance: ₹{accountBalance}</p>
    <button type="button" onClick={handleApplyByWallet} className="btn btn-primary">
      Apply by Wallet
    </button>

    {showConfirmBar && (
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        backgroundColor: '#f8f9fa', padding: '1rem', boxShadow: '0 -2px 10px rgba(0,0,0,0.2)'
      }}>
        {canApply ? (
          <>
            <p>Confirm payment of ₹70 from wallet?</p>
            <button type="submit" className="btn btn-success me-2">Yes, Pay</button>
            <button onClick={() => setShowConfirmBar(false)} className="btn btn-secondary">Cancel</button>
          </>
        ) : (
          <p className="text-danger">❌ Insufficient Balance</p>
        )}
      </div>
    )}
  </div>
                                    </div>
                                </form>
                                {message && <p>{message}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            {/* <Footer /> */}
        </div>
    );
};

export default WalletExam;





